import { OptionalFeature } from "../../../../base/domain/drawing";
import { ITooltipBehavior } from "./ITooltipBehavior";

export class TooltipBehavior extends OptionalFeature {
  constructor(
    isEnable: boolean       = false,
    public message: string  = ""
  ) {
    super(isEnable);
  }

  clone(): TooltipBehavior {
    return new TooltipBehavior(this.isEnable, this.message);
  }

  static from(source: ITooltipBehavior): TooltipBehavior {
    return new TooltipBehavior(source.isEnable, source.message);
  }

  static to(source: TooltipBehavior): ITooltipBehavior {
    return {
      isEnable: source.isEnable,
      message: source.message,
    };
  }
}
